import Cookies from 'js-cookie';

var homepageWidths = function() {
  if (!Modernizr.csscalc) {
    if ($('.homepage__right__width').length) {
      var setWidth = function() {
        var windowWidth = $(window).width(),
            sidebarWidth = $('.homepage__right__width').width(),
            newWidth = windowWidth - sidebarWidth;

        $('.homepage__left').width(newWidth);
      };

      setWidth();

      $(document).on('resized', function() {
        setWidth();
      });
    }
  }
};

var selectedOffice = function() {
  var cookieName = 'aab-selected-office';
  //Check if element exist
  if ($('.selected-office').length) {
    var $container = $('.selected-office'),
        $select = $container.find('[data-office-select]'),
        defaultOfficeID = $container.attr('data-default'),
        selectedOfficeID = defaultOfficeID,
        allOffices = [],
        setCookie = function(id) {
          //Check if cookie exist
          if (Cookies.get('functionality')) {
            Cookies.set(cookieName, id);
            selectedOfficeID = id;
          }
        },
        getSelectedIndex = function(id) {
          var officeIndex = 0;

          $.each(allOffices, function(index, office) {
            if (office.id === parseInt(id)) {
              officeIndex = index;
            }
          });

          return officeIndex;
        },
        setOffice = function(index) {
          $container.addClass('loading');
          setTimeout(function() {
            var office = allOffices[index];

            $container.find('[data-office-title]').text(office.title);
            $container.find('[data-office-image]').css({"background-image":"url('"+office.image+"')"});
            $container.find('[data-office-link]').attr({'href': office.url});
            $container.find('[data-office-address]').attr({'href': office.url}).text(office.address);
            $container.find('[data-office-phone]').attr({'href': 'tel:'+office.phoneNumber.replace(' ', '')}).text(office.phoneNumber);

            setCookie(office.id);
            setTimeout(function() {
              $container.removeClass('loading');
            }, 200);
          }, 200);
        };

    $.ajax({
      dataType: "json",
      url: siteUrl+'api/offices',
      success: function(response) {

        var officesData = response.data;
        var currentLang = $('html').attr('lang');

        var aland = officesData[0].offices;
        var finland = officesData[1].offices;
        var sverige = officesData[2].offices;

        switch(currentLang) {
          case 'en-GB':
          case 'sv-AX':
            allOffices = aland.concat(finland, sverige);
            break;
          case 'sv-FI':
          case 'fi-FI':
            allOffices = finland.concat(aland, sverige);
            break;
          case 'sv-SE':
            allOffices = sverige.concat(aland, finland);
            break;
        }

        //Populate Office select
        if ($select.length) {
          $.each(allOffices, function(index, office) {
            $select.append('<option value="'+office.id+'">'+office.title+'</option>');
          });
        }

        //Check if cookie exist
        if (Cookies.get(cookieName)) {
          selectedOfficeID = Cookies.get(cookieName);
        }

        var selectedOfficeIndex = getSelectedIndex(selectedOfficeID);

        $select.val(selectedOfficeID);

        setOffice(selectedOfficeIndex);

      }
    });

    $select.on('change', function() {
      var officeIndex = getSelectedIndex($(this).val());
      setOffice(officeIndex);
    });
  }
};

$(document).ready(function() {
  homepageWidths();
  selectedOffice();
});
